module.exports = __webpack_public_path__ + "static/media/carousal_2.68c581c3.png";